<template>
  <div class="lostRecord">
    <v-card class="col-12 pt-0 pb-0">
      <!--div class="row justify-end pt-3 pr-3 pd -3">
        <v-btn small color="primary" dense @click="lostNotificationSmsSetting()">분실 알림 SMS 설정</v-btn>
      </div-->

      <v-data-table
        :headers="headers"
        :items="productInfos"
        :server-items-length="productInfosCount"
        :options.sync="options"
        :loading="tableLoading"
        :items-per-page="$parent.$refs.lostSearchComponent.searchPayload.limit"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50],
          'items-per-page-text': '목록 노출 수 선택:',
        }"
      >
        <template v-slot:[`item.image`]="{ item }" class="pl-0 pr-0 ml-0 mr-0">
          <v-row no-gutters>
            <v-col>
              <v-img v-if="item.list_image" :src="item.list_image" width="60px" height="60px" style="display: inline-block;"></v-img>
              <v-img v-else :src="adminDefaultImg" width="60px" height="60px" style="display: inline-block;"></v-img>
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.productInfo`]="{ item }" class="pl-0 pr-0 ml-0 mr-0">
          <v-row no-gutters>
            <v-col class="ml-0" cols="12" style="max-width: 400px; overflow: hidden; text-overflow: ellipsis; ; white-space: nowrap;">
              <p class="mb-0 mt-3 text-left text-truncate caption">
                {{ item.product_name }}
              </p>
              <p class="mb-0 text-left text-truncate caption">옵션 : {{ item.variant_name }}</p>
              <p class="mb-0 text-left text-truncate caption">상품코드 : {{ item.product_code }}</p>
              <p class="mb-3 text-left text-truncate caption">품목코드 : {{ item.variant_code }}</p>
            </v-col>
          </v-row>
        </template>

        <template v-slot:[`item.lostDay`]="{ item }" class="pl-0 pr-0">
          <p class="mb-0 text-center caption" v-html="$options.filters.defaultDate(item.lost_at)"></p>
        </template>

        <template v-slot:[`item.authCode`]="{ item }" class="pl-0 pr-0">
          <p class="mb-0 mt-3 caption" @click="authCodeClick(item)">
            <a>{{ item.serial_number }}</a>
          </p>
        </template>

        <template v-slot:[`item.warrantyPeriodDays`]="{ item }" class="pl-0 pr-0">
          <a
            @click="daysClick(item)"
            class="caption"
            v-html="
              $options.filters.warrantyPeriod({
                cert_status: item.cert_status,
                cert_duration_type: item.cert_duration_type,
                cert_duration: item.cert_duration,
                cert_validated_at: item.cert_validated_at,
                cert_expired_at: item.cert_expired_at,
                bought_at: item.bought_at,
              })
            "
          ></a>
        </template>

        <template v-slot:[`item.authState`]="{ item }" class="pl-0 pr-0">
          <a @click="authStateClick(item)" class="caption">{{ item.cert_status | certStatus }}</a>
        </template>

        <template v-slot:[`item.authDate`]="{ item }" class="pl-0 pr-0">
          <p class="mb-0 text-center caption" v-html="$options.filters.defaultDate(item.activated_at)"></p>
        </template>

        <template v-slot:[`item.authUserId`]="{ item }" class="pl-0 pr-0">
          <p class="mb-0 text-center caption">
            <a v-if="item.member_id !== null" :href="moveEcUserPage(item.member_id)" target="_blank">{{
              item.member_id | defaultString
            }}</a>
            <span v-else>{{ item.member_id | defaultString }}</span>
          </p>
        </template>

        <template v-slot:[`item.authAttempt`]="{ item }" class="pl-0 pr-0">
          <p class="mb-0 text-center caption">
            <a v-if="item.number_of_lost_trial > 0" @click="authAttempt(item)">{{ item.number_of_lost_trial }}</a>
            <span v-else>{{ item.number_of_lost_trial }}</span>
          </p>
        </template>

        <template slot="no-data">
          <div class="noDataProductInfos">내역이 없습니다.</div>
        </template>
      </v-data-table>

      <AuthCodeClickModal ref="AuthCodeClickModal"></AuthCodeClickModal>
      <AuthWarrantyPeriodChangeModal ref="AuthWarrantyPeriodChangeModal"></AuthWarrantyPeriodChangeModal>
      <UnAuthWarrantyPeriodChangeModal ref="UnAuthWarrantyPeriodChangeModal"></UnAuthWarrantyPeriodChangeModal>
      <AuthStateChangeModal ref="AuthStateChangeModal"></AuthStateChangeModal>
      <AuthAttemptModal ref="AuthAttemptModal"></AuthAttemptModal>
      <lostNotificationSmsSettingModal ref="lostNotificationSmsSettingModal"></lostNotificationSmsSettingModal>
    </v-card>
  </div>
</template>
<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}

.lostRecord a:hover {
  text-decoration: underline;
}
</style>
<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";
import AuthWarrantyPeriodChangeModal from "@/components/authservice/authcode/modal/AuthWarrantyPeriodChangeModal.vue";
import UnAuthWarrantyPeriodChangeModal from "@/components/authservice/authcode/modal/UnAuthWarrantyPeriodChangeModal.vue";
import AuthAttemptModal from "@/components/authservice/lostRecord/modal/AuthAttemptModal.vue";
import lostNotificationSmsSettingModal from "@/components/authservice/lostRecord/modal/lostNotificationSmsSettingModal.vue";
import AuthStateChangeModal from "@/components/authservice/authcode/modal/AuthStateChangeModal.vue";
import AuthCodeClickModal from "@/components/authservice/authcode/modal/AuthCodeClickModal.vue";

export default {
  data() {
    return {
      headers: [
        {
          text: "이미지",
          align: "center",
          value: "image",
          sortable: false,
          width: 70,
        },
        {
          text: "품목정보",
          align: "center",
          value: "productInfo",
          sortable: false,
          width: 150,
        },
        {
          text: "분실일시",
          align: "center",
          value: "lostDay",
          sortable: false,
          width: 100,
        },
        {
          text: "정품인증코드",
          align: "center",
          value: "authCode",
          sortable: false,
          width: 180,
        },
        {
          text: "보증기간",
          align: "center",
          value: "warrantyPeriodDays",
          sortable: false,
          width: 120,
        },
        {
          text: "인증상태",
          align: "center",
          value: "authState",
          sortable: false,
          width: 90,
        },
        {
          text: "인증일시",
          align: "center",
          value: "authDate",
          sortable: false,
          width: 100,
        },
        {
          text: "인증회원정보",
          align: "center",
          value: "authUserId",
          sortable: false,
          width: 110,
        },
        {
          text: "인증시도",
          align: "center",
          value: "authAttempt",
          sortable: false,
          width: 90,
        },
      ],
      productInfos: [],
      productInfosCount: 0,
      options: {},
      tableLoading: false,
      adminDefaultImg: require("../../../assets/authservice/images/admin_default.png"),
    };
  },
  components: {
    AuthWarrantyPeriodChangeModal,
    UnAuthWarrantyPeriodChangeModal,
    AuthAttemptModal,
    lostNotificationSmsSettingModal,
    AuthStateChangeModal,
    AuthCodeClickModal,
  },
  mixins: [CommonMixin],
  filters: Filters,
  watch: {
    options: {
      handler() {
        this.$parent.$refs.lostSearchComponent.execSearch(false);
      },
      deep: true,
    },
  },
  /**
   * 라이프 사이클로 오류 발생으로 created -> updated로 변경 ( watch와 오류 발생 )
   */
  updated: function() {
    this.eventHub.$on("setLostList", this.setProductList);
  },
  methods: {
    setProductList: function(data) {
      this.productInfosCount = data.count;
      this.productInfos = data.serials.map((serial) => {
        return {
          ...serial,
          product_name: serial.product_name.replace(/<\/?[^>]+(>|$)/g, ""),
        };
      });
      this.tableLoading = false;
    },
    daysClick: function(data) {
      this.$refs.UnAuthWarrantyPeriodChangeModal.warrantyPeriodClick(data);
    },
    authStateClick: function(data) {
      this.$refs.AuthStateChangeModal.authStateClick(data);
    },
    authCodeClick: function(data) {
      this.$refs.AuthCodeClickModal.authCodeClick(data);
    },
    authAttempt: function(data) {
      this.$refs.AuthAttemptModal.authAttempt(data);
    },
    lostNotificationSmsSetting: function(data) {
      this.$refs.lostNotificationSmsSettingModal.lostNotificationSmsSetting(data);
    },
  },
};
</script>
